import { CircularProgress, Modal, Paper, Slide } from '@material-ui/core'

import SectionTitle from '../../../components/SectionTitle'
import { getDirection } from '../../../localization'
import { AllocationMismatch } from '../../../types/allocateMismatch'
import ReservationNumbersModalRow from './ReservationNumbersModalRow'
import ReservationNumbersModalTableHead from './ReservationNumbersModalTableHead'
import useStyles from './styles/index.styles'

interface ReservationNumbersModalProps {
  isOpen: boolean
  onClose: () => void
  data: AllocationMismatch
}
const ReservationNumbersModal: React.FC<ReservationNumbersModalProps> = ({
  isOpen,
  onClose,
  data
}) => {
  const classes = useStyles()
  const longerReservationNumberList =
    data.bookingListReservationNumbers.length >
    data.allocateHistoryReservationNumbers.length
      ? 'booking'
      : 'history'
  return (
    <Modal dir={getDirection()} open={isOpen} onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          <div className={classes.titleContainer}>
            <SectionTitle title="Reservation Numbers" marginBottom />
          </div>
          <ReservationNumbersModalTableHead />
          {data ? (
            longerReservationNumberList === 'booking' ? (
              <>
                {data?.bookingListReservationNumbers.map((item, index) => (
                  <ReservationNumbersModalRow
                    bookingListReservation={item}
                    historyReservation={
                      data.allocateHistoryReservationNumbers[index] || ''
                    }
                    index={index}
                  />
                ))}
              </>
            ) : (
              <>
                {data?.allocateHistoryReservationNumbers.map((item, index) => (
                  <ReservationNumbersModalRow
                    historyReservation={item}
                    bookingListReservation={
                      data.bookingListReservationNumbers[index] || ''
                    }
                    index={index}
                  />
                ))}
              </>
            )
          ) : (
            <div className={classes.circularProgressContianer}>
              <CircularProgress color="primary" />
            </div>
          )}
        </Paper>
      </Slide>
    </Modal>
  )
}

export default ReservationNumbersModal
